import script from "./StudentChallengePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./StudentChallengePage.vue?vue&type=script&setup=true&lang=ts"

import "./StudentChallengePage.vue?vue&type=style&index=0&id=49ad5693&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49ad5693"]])

export default __exports__